import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Router from './router/Router';

// English fonts
import './assets/fonts/Shubbak/Shubbak_Black.ttf';
import './assets/fonts/Shubbak/Shubbak_Bold.ttf';
import './assets/fonts/Shubbak/Shubbak_ExtraBold.ttf';
import './assets/fonts/Shubbak/Shubbak_ExtraLight.ttf';
import './assets/fonts/Shubbak/Shubbak_Light.ttf';
import './assets/fonts/Shubbak/Shubbak_Medium.ttf';
import './assets/fonts/Shubbak/Shubbak_Regular.ttf';
import './assets/fonts/Shubbak/Shubbak_SemiBold.ttf';

// Arabic fonts
import './assets/fonts/Almarai/Almarai-Bold.ttf';
import './assets/fonts/Almarai/Almarai-ExtraBold.ttf';
import './assets/fonts/Almarai/Almarai-Light.ttf';
import './assets/fonts/Almarai/Almarai-Regular.ttf';

// Saudi Riyal Symbol font
import './assets/fonts/SaudiRiyal/Saudi-Riyal.ttf';

import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'sonner';

if (!window.location.hash) {
    window.location.replace('/#' + window.location.pathname + window.location.search);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <>
        <Provider store={store}>
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <Toaster
                    toastOptions={{
                        style: {
                            backgroundColor: '#fff',
                            borderColor: '#ccc',
                            color: 'black',
                        },
                        descriptionClassName: 'toast-description',
                    }}
                />
                <Router />
            </PersistGate>
        </Provider>
    </>
);

reportWebVitals();
